import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import campImg from "../../Assets/camp1.png";
import Tilt from "react-parallax-tilt";


import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


function Camps2() {
  const { t } = useTranslation();

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/registration#techcamps-section"); // This will navigate to the "/another-page" route
  };




    const videoId = "5mPU-mIQgoQ"; 
return (
    <Container fluid className="home-about-section" id="about">
    <Container>
        <Row>
        <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              {t("programs.camps.header.titleLeft")}
              <span className="purple"> {t("programs.camps.header.titleRight")}</span>
            </h1>
            <p className="home-about-body">{t("programs.camps.description.p1")}</p>
            <p className="home-about-body">{t("programs.camps.description.p2")}</p>
          <Button onClick={handleClick}>{t("common.registerHere")}</Button>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={campImg} className="img-fluid" alt={t("programs.camps.imageAlt")} />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>{t("common.summerInternshipProgram")}</h1>
          <Container>    
      
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', marginBottom: '20px' }}>
                                <iframe
                                  title={t("common.youtubeVideo")}
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
      </div>
    </Container>
           
          </Col>
            </Row>

            
                <Col md={12} className="home-testimonial">
                <h1>{t("common.testimonials")}</h1>
                </Col>
          
            


      </Container>
    </Container>
  );
}
export default Camps2;
